var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application"},[_c('AppHeader',{attrs:{"justify-space-between":""}}),_c('AppNotificationBar',[_vm._v("\n    Application Successful. Confirmation Number: "+_vm._s(_vm.confirmationNumber)+"\n  ")]),_c('div',{staticClass:"application__content"},[_c('StepHandlerDocuments')],1),_c('AppFooter'),_c('AppCookieManager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }